import React, { useRef, useState, useEffect } from 'react';
import { CButton, CCard, CCardBody, CContainer, CForm, CFormInput, CFormLabel, CCardFooter } from '@coreui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import '../styles/Login.css';

const ChangePassword = () => {
    const [error, setError] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [username, setUsername] = useState('');
    const navigate = useNavigate();

    const newPasswordRef = useRef();
    const confirmNewPasswordRef = useRef();

    const location = useLocation();

    useEffect(() => {
        const queryString = window.location.search.substring(1);
        const usernameWithoutPrefix = queryString.replace("username=", "");
        setUsername(usernameWithoutPrefix);
    }, [location]);

    function validatePassword(password) {
        const minLength = 8;
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const digitRegex = /\d/;

        if (password.length < minLength) {
            return "Password must be at least 8 characters long.";
        }
        if (!uppercaseRegex.test(password)) {
            return "Password must contain at least one uppercase letter.";
        }
        if (!lowercaseRegex.test(password)) {
            return "Password must contain at least one lowercase letter.";
        }
        if (!digitRegex.test(password)) {
            return "Password must contain at least one digit.";
        }

        return null;
    }

    function handleSubmit(e) {
        e.preventDefault();

        const newPasswordValue = newPasswordRef.current.value;
        const confirmNewPasswordValue = confirmNewPasswordRef.current.value;

        if (newPasswordValue === '' || confirmNewPasswordValue === '') {
            setError('Please fill in all fields.');
            return;
        }



        if (newPasswordValue !== confirmNewPasswordValue) {
            setError('New password and confirm new password must match.');
            return;
        }

        const passwordError = validatePassword(newPasswordValue);
        if (passwordError) {
            setError(passwordError);
            return;
        }

        const formData = new FormData();

        formData.append("username", username)
        formData.append("password", newPassword)

        fetch("/api/user/changePassword",
            {
                method: 'POST',
                body: formData
            }
        ).then((res) => {
            if (res.ok) {
                toast.success('Password changed successfully!', {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: 'colored'
                });

                setNewPassword('');
                setConfirmNewPassword('');
                setError(null);
                navigate('/login');
            } else if (res.status === 401) {
                toast.error(` Please contact HR to reset your password.`, {
                    closeButton: true,
                    autoClose: true,
                    position: toast.POSITION.BOTTOM_CENTER,
                    theme: "colored"
                });
            } else {
                throw new Error("An error has occured. Please try again later.")
            }
        }).catch((error) => {
            setError(error.message)
        })



        //setNewPassword('');
        //setConfirmNewPassword('');
        //setError(null);
    }

    return (
        <CContainer id='login-container' fluid className="login-bg">
            <CCard className="login-card-bg">
                <CCardBody>
                    <CForm onSubmit={handleSubmit}>
                        <h2>Change Password</h2>
                        <CFormLabel className="required-label mt-3">New Password</CFormLabel>
                        <CFormInput className="mb-4" type="password" ref={newPasswordRef} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                        <CFormLabel className="required-label">Confirm New Password</CFormLabel>
                        <CFormInput className="mb-2" type="password" ref={confirmNewPasswordRef} value={confirmNewPassword} onChange={(e) => setConfirmNewPassword(e.target.value)} />
                        <div className="password-conditions">
                            <p>Password must:</p>
                            <ul>
                                <li>Be at least 8 characters in length.</li>
                                <li>Contain at least one uppercase letter.</li>
                                <li>Contain at least one lowercase letter.</li>
                                <li>Contain at least one digit.</li>
                            </ul>
                        </div>
                        <div className="d-flex justify-content-end mt-4"><CButton type="submit" color="primary">Change Password</CButton></div>

                        {error && <p style={{ color: 'red', fontWeight: '600', fontSize: '20px' }}>{error}</p>}

                    </CForm>
                </CCardBody>
            </CCard>
        </CContainer>
    );
}

export default ChangePassword;
